






































































































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {GetPatCaseHistory, SavePatCaseHistory} from "@/api/hd"
import {getLodop} from "@/lib/lodop"

@Component({
	components: {}
})
export default class PatientInfo extends AbpBase {
	@Prop() patient: any
	currentYear = new Date().getFullYear()
	patientInfo: any = {

		patient: {},
		patientAllergyHistory: []
	}
	patCaseHist: any = {
		id: 0,
		chiefComplaint: '主诉：',
		chiefComplaintDeclare: '{出生地、居住地区和居留时间(尤其是疫源地和地方性疾病流行区)、受教育程度、经济生活和业余爱好等。不同传染病有不同潜伏期,应根据考虑的疾病,询问过去某段时间是否去过疫源地}。{工种、劳动环境、对工业毒物的接触情况及时间}。{起居与生活习惯、饮食的规律与质量。烟酒嗜好时间与摄入量,以及其他异嗜物和麻醉药品、毒品等},{有无不洁性交,是否患过淋病性尿道炎、尖锐湿疣、下疳等}。',
		previousHistory: '呼吸系统:{无慢性咳嗽、咯血、呼吸困难、胸痛、食欲不振、发冷、发热、盗汗史}。\n' +
			'\n' +
			'循环系统:{无心悸、心前区疼痛、呼吸困难、咳嗽、咯血},{无水肿、腹水、肝区疼痛、头痛、头晕、晕厥},{无风湿热、心脏疾病、高血压病、动脉硬化等病史},{女性患者应询问妊娠、分娩时有无高血压和心功能不全的情况}。\n' +
			'\n' +
			'消化系统:{无食欲改变、反酸、嗳气、吞咽困难、呕吐、腹痛、腹胀、腹泻、呕血及黑便史}, {有无发热与皮肤巩膜黄染,体力、体重的改变},{有无口腔疾病,上述症状与食物种类、性质的关系',
		personalHistory: '平素{身体健康},{否认急性传染病史},有无其他疾病{有疾病按照时间先后},幼年曾接种{卡介苗、脊灰疫苗、百白破三联疫苗},{最近一次接种疫苗种类及接种日期}。过敏史(如有临床表现详细描述)外伤史,手术史。输血史。',
		physicalExamination: '四诊合参，本病当属祖国医学之“咳嗽”范畴，证属“风热型”。缘患儿年幼，肺气虚弱，为风热之邪所袭，邪闭肺络，肺气失于宣肃，腠理开合失度，可致发热，咳嗽。鼻咽为肺胃之门，感受风热之邪故见咽红。肺与脾密切相关，肺气受损则脾气亦虚，故见纳呆，胃失和降则呕吐，运化失常则大便烂。舌红，苔白，脉浮数均为外感风热之征',
		auxiliaryExamination: '1.病史：反复发热、咳嗽5天。\n' +
			'2.症状、体征：发热，咳嗽，有痰，呕吐胃内容物一次，耳痛，纳呆，睡眠差，大便烂。咽充血(+++)，双扁桃体II°大。双肺呼吸音粗，双下肺可闻及少量干湿性罗音。\n' +
			'3、 辅助检查：血分析：WBC 12.6x10e9/L， GRAN%76.2%，胸片示：双肺支气管感染。\n' +
			'入院诊断',
		diagnose: '诊断：',
		dtp: '颈部： 形：对称，无异常肿块XXXXXX。 态：无抵抗强直、压痛，活动无受限XXXXXX。 气管：位置居中XXXXXX。 甲状腺：无肿大或结节XXXXXX。 颈脉：无异常搏动及杂音，颈静脉无怒张，无肝颈回流征XXXXXX。 胸部： 胸廓：外观对称，无畸形，肋间隙正常，无局部隆起、凹陷、压痛及叩击痛，无水肿、皮下气肿、肿块，静脉无怒张及回流异常XXXXXX。 ',
	}

	created() {
		this.init()
	}

	async save() {
		this.patCaseHist.patientId = this.patient.id
		let res = await SavePatCaseHistory(this.patCaseHist)
	}

	private async init() {
		let res = await GetPatCaseHistory({patientId: this.patient.id})
		this.patientInfo = res.objects
		this.patCaseHist = res.objects.patCaseHist || this.patCaseHist
	}

	print() {
		let lodop
		try {
			lodop = getLodop()
			let html = `<body>${(this.$refs.printBody as any).innerHTML}</body>`
			lodop.SET_PRINT_STYLE("FontSize", 14);
			// lodop.SET_PRINT_STYLE("Bold", 1);
			lodop.ADD_PRINT_TEXT(0, 0, 0, 0, "打印页面部分内容");
			//增加超文本打印项，设定该打印项在纸张内的位置和区域大小，实现超文本控制打印。
			lodop.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "100%")
			lodop.ADD_PRINT_HTM(34,34,"RightMargin:0.9cm","BottomMargin:9mm", html);
			lodop.SET_PRINT_PAGESIZE(1, 0, 0, "A4"); //规定纸张大小；使用A4纸。
			// lodop.SET_SHOW_MODE("LANDSCAPE_DEFROTATED", 1);//横向时的正向显示
			lodop.PREVIEW();
		} catch (e) {

		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/bloodRecord/index.vue